import { Line } from "rc-progress";

function ProgressBar({ level, isleading, isTrailing, max }) {
  return (
    <div className="px-4">
      <div className="flex items-center justify-between gap-4 my-1.5">
        {isleading && (
          <span className="flex items-center gap-[0.3rem] text-sm text-primary-main">
            19760 pts
          </span>
        )}
        {isTrailing && (
          <span className="flex items-center justify-end text-sm ">
            <span className="text-[#0000004D] flex items-center gap-1">
              20000 pts
            </span>
          </span>
        )}
      </div>
      <div className="flex justify-center w-full items-center">
        <div className="w-full">
          <Line
            className="col-span-8 bg-white  rounded-2xl"
            percent={(level / max) * 100}
            strokeWidth={3}
            strokeColor="#1c56e2"
            trailColor="#fff"
            steps={2}
            strokeLinecap="round"
            gapDegree={200}
            gapPosition="bottom"
          />
        </div>
      </div>
      <div className="flex items-center justify-between gap-4 my-1.5">
        {isleading && (
          <span className="flex items-center gap-[0.3rem] text-sm text-primary-main">
            Lvl {level}
          </span>
        )}
        {isTrailing && (
          <span className="flex items-center justify-end text-sm ">
            <span className="text-[#0000004D] flex items-center gap-1">
              Lvl
              {level + 1}
            </span>
          </span>
        )}
      </div>
    </div>
  );
}

export default ProgressBar;
